import {NgModule} from '@angular/core';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {environment} from '../../environments/environment';
import {PathwaysBackendMockModule} from '@ispm-client/modules/backend-mock-modules/pathways-backend-mock/pathways-backend-mock.module';
import {WidgetsModule} from '@ispm/widgets/widgets.module';
import {SharedModule} from '@ispm/shared/shared.module';
import {LoadProgressionEffects} from '@ispm-client/modules/pathway-selections/store/effects/load-progression.effects';
import {PathwaysListComponent} from '@ispm-client/modules/pathway-selections/pathways-list.component/pathways-list.component';
import {pathwaySelectionsReducer} from '@ispm-client/modules/pathway-selections/store/reducers/pathway-selections.reducer';
import {SmartNoteComponent} from '@ispm-client/modules/pathway-selections/smart-note.component/smart-note.component';
import {GeneralDialogComponent} from "@ispm-client/modules/pathway-selections/general-dialog/general-dialog.component";


@NgModule({
  declarations: [
    PathwaysListComponent,
    SmartNoteComponent,
    GeneralDialogComponent
  ],
  imports: [
    SharedModule,
    WidgetsModule,
    StoreModule.forFeature('pathwaySelections', pathwaySelectionsReducer),
    environment.production ? [] : PathwaysBackendMockModule,
    EffectsModule.forFeature([LoadProgressionEffects])
  ],
  exports: [
    PathwaysListComponent,
    SmartNoteComponent
  ]
})
export class PathwaySelectionsModule { }
